import React from 'react';
import { Button, Text, getTokenValue, Token, XStack } from 'tamagui';
import { hexToRGBA } from 'tamagui-config';

interface GradientButtonProps {
  label: string;
  isActive?: boolean;
  onPress?: () => void;
  icon?: React.ReactNode;
  width?: string;
}

export const GradientButton: React.FC<GradientButtonProps> = ({
  label,
  isActive = false,
  onPress,
  icon,
  width,
  ...rest
}) => {
  const gradientStartColor = getTokenValue('$hgPrimaryGradientStart' as Token, 'color');
  const gradientEndColor = getTokenValue('$hgPrimaryGradientEnd' as Token, 'color');
  const elevatedShadowColor = getTokenValue('$hgPrimary' as Token, 'color');
  const gradient = `linear-gradient(106deg, ${gradientStartColor} 0%, ${gradientEndColor} 100%)`;
  const boxShadow = `0px 4px 24px 0px ${hexToRGBA(elevatedShadowColor, 0.25)}`;

  return (
    <Button
      borderRadius={36}
      borderWidth={0}
      height="72px"
      padding="$4"
      backgroundImage={gradient}
      opacity={isActive ? 1 : 0.5}
      boxShadow={boxShadow}
      pressStyle={{ opacity: 0.8 }}
      onPress={onPress}
      disabled={!isActive}
      {...(width ? { width } : {})}
      {...rest}>
      <XStack alignItems="center" gap="$4">
        {icon}
        <Text color="$white12" fontSize="$8.5">
          {label}
        </Text>
      </XStack>
    </Button>
  );
};
